import noop from 'lodash/noop';
import flatten from 'lodash/flatten';
import dayjs from 'dayjs';

const $hnxUtils = function () {
	const timeParser = function (input) {
		const regex = /^(\d|0\d|1\d|2[0-3]):?([0-5]\d)?:?([0-5]\d)?$/;

		if (regex.test(input)) {
			let arr = [];

			if (input.indexOf(':') > -1) {
				arr = input.split(':');
			} else {
				arr = input.split('').reverse().join('').match(/\d{1,2}/g).map(element => element.split('').reverse().join('')).reverse();
			}

			const m = dayjs().second(0).hour(arr[0]);
			if (arr.length > 1) {
				m.minute(arr[1]);
			} else {
				m.minute(0);
			}
			return m;
		}
		return null;
	};

	const taskQueue = function (...tasks) {
		tasks = flatten(tasks);
		
		let qResolve = noop;
		const qPromise = new Promise(((resolve) => {
			qResolve = resolve;
		}));
		
		const mapTask = function (task) {
			return function () {
				return new Promise(((resolve) => {
					const result = task.action();
					window.setTimeout(() => resolve(result), task.duration || 0);
				}));
			};
		};
		
		const promises = tasks.map(mapTask);
		
		const push = function (task) {
			const mTask = mapTask(task);
			promises.push(mTask);
		};

		const resolver = function (counter = 0) {
			if (promises[counter]) {
				return promises[counter]().then(() => resolver(counter + 1));
			} else {
				qResolve();
				return qPromise;
			}
		};

		return {
			run: () => resolver(),
			promise: qPromise,
			push
		};
	};

	return {
		timeParser,
		taskQueue
	};
}();

export default $hnxUtils;
